import { render, staticRenderFns } from "./MoneyPlacementCreateForm.vue?vue&type=template&id=c1a65696&"
import script from "./MoneyPlacementCreateForm.vue?vue&type=script&lang=js&"
export * from "./MoneyPlacementCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports